import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#B87AFF]/20 py-10 px-4" data-id="element-177">
      <div className="max-w-3xl mx-auto text-center" data-id="element-178">
        <div className="text-[#B87AFF] text-2xl font-black tracking-widest mb-4" data-id="element-179">
          🧘 EDULABS™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-180">
          El sistema de clases N°1 para profesores de yoga en español.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-181">
          Porque enseñar yoga no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-182">
          <span data-id="element-183">📧 soporte@edulabs.com</span>
          <span className="hidden sm:inline" data-id="element-184">•</span>
          <span data-id="element-185">📲 @edulabs</span>
          <span className="hidden sm:inline" data-id="element-186">•</span>
          <span data-id="element-187">🌐 www.edulabs.com</span>
        </div>

        <div className="h-px bg-[#B87AFF]/20 mb-6" data-id="element-188" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-189">
          © EDULABS™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-190">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}